/**
 * UI-тексты разрозненных виджетов (Misc widgets):
 *   - layout/Header.jsx — навигация + aria-labels
 *   - SanityTable.jsx   — бейдж «Выбор» в таблицах
 *   - city/WeatherBlock.jsx — погодные ярлыки, дни недели, заголовки/aria
 * Только UI-литералы (бывшие inline isRu/lang === 'ru' ? … : …).
 * RU и EN имеют идентичную форму ключей.
 */
export const miscUi = {
    en: {
        // ── Header: навигация ──
        nav: {
            countries: 'Countries',
            cities: 'Cities',
            esim: 'eSIM',
            vpn: 'VPN',
            tours: 'Tours',
            transport: 'Transport',
            stay: 'Stay',
            insurance: 'Insurance',
            blog: 'Blog',
            contact: 'Contact',
        },
        // ── Header: aria-labels ──
        aria: {
            primaryNav: 'Primary navigation',
            mobileMenu: 'Mobile menu',
            switchLang: 'Switch language',
            openMenu: 'Open menu',
            closeMenu: 'Close menu',
        },
        // ── SanityTable: бейдж рекомендованной строки ──
        pick: 'Pick',
        // ── WeatherBlock ──
        weather: {
            now: 'Weather now',
            feels: 'Feels',
            humidity: 'Humidity',
            wind: 'Wind',
            windUnit: (speed) => `${speed} m/s`,
            factsAria: (cityName) => `Facts & weather · ${cityName}`,
        },
        // Погодные состояния (key = OpenWeather "main", lowercased)
        conditions: {
            thunderstorm: 'Thunderstorm',
            drizzle: 'Drizzle',
            rain: 'Rain',
            snow: 'Snow',
            mist: 'Mist',
            smoke: 'Smoke',
            haze: 'Haze',
            dust: 'Dust',
            fog: 'Fog',
            sand: 'Sandstorm',
            ash: 'Volcanic ash',
            squall: 'Squall',
            tornado: 'Tornado',
            clear: 'Clear',
            clouds: 'Cloudy',
            fewClouds: 'Partly cloudy',
        },
        // Короткие дни недели (index = Date.getDay(), 0 = воскресенье)
        weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    },
    ru: {
        nav: {
            countries: 'Страны',
            cities: 'Города',
            esim: 'eSIM',
            vpn: 'VPN',
            tours: 'Туры',
            transport: 'Транспорт',
            stay: 'Жильё',
            insurance: 'Страховка',
            blog: 'Блог',
            contact: 'Контакты',
        },
        aria: {
            primaryNav: 'Основная навигация',
            mobileMenu: 'Мобильное меню',
            switchLang: 'Сменить язык',
            openMenu: 'Открыть меню',
            closeMenu: 'Закрыть меню',
        },
        pick: 'Выбор',
        weather: {
            now: 'Погода сейчас',
            feels: 'Ощущается',
            humidity: 'Влажность',
            wind: 'Ветер',
            windUnit: (speed) => `${speed} м/с`,
            factsAria: (cityName) => `Факты и погода · ${cityName}`,
        },
        conditions: {
            thunderstorm: 'Гроза',
            drizzle: 'Морось',
            rain: 'Дождь',
            snow: 'Снег',
            mist: 'Дымка',
            smoke: 'Смог',
            haze: 'Мгла',
            dust: 'Пыль',
            fog: 'Туман',
            sand: 'Песчаная буря',
            ash: 'Вулканический пепел',
            squall: 'Шквал',
            tornado: 'Торнадо',
            clear: 'Ясно',
            clouds: 'Облачно',
            fewClouds: 'Переменная облачность',
        },
        weekdays: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
    },
};
